<template>
  <div class="prompt-variables bg-white br-10px">
    <h4>Available Variables</h4>
    <p class="subtitle">Click to copy variable name</p>

    <div class="variables-list">
      <div
        v-for="variable in variables"
        :key="variable.key"
        class="variable-item"
        @click="copyVariable(variable.key)"
        :title="variable.description"
      >
        <code class="variable-key">{{ formatVariable(variable.key) }}</code>
        <span class="variable-type">{{ variable.type }}</span>
        <p class="variable-description">{{ variable.description }}</p>
      </div>

      <div v-if="variables.length === 0" class="no-variables">No variables available for this prompt type.</div>
    </div>

    <div v-if="copied" class="copied-toast">Copied!</div>
  </div>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  variables: {
    type: Array,
    default: () => [],
  },
});

const copied = ref(false);

const formatVariable = (key) => `{{${key}}}`;

const copyVariable = (key) => {
  const text = `{{${key}}}`;
  navigator.clipboard.writeText(text);

  copied.value = true;
  setTimeout(() => {
    copied.value = false;
  }, 1500);
};
</script>

<style lang="scss" scoped>
.prompt-variables {
  padding: 16px;
  position: relative;

  h4 {
    margin: 0 0 2px 0;
  }
}

.subtitle {
  margin: 0 0 14px 0;
  font-size: 13px;
  color: $color-text-muted;
}

.variables-list {
  max-height: 400px;
  overflow-y: auto;
}

.variable-item {
  padding: 10px 12px;
  border: 1px solid $color-border;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition:
    border-color 150ms ease-out,
    background-color 150ms ease-out;

  &:hover {
    border-color: $color-primary;
    background: $color-surface-muted;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.variable-key {
  display: block;
  font-size: 13px;
  color: $color-primary;
  background: rgba($color-primary, 0.08);
  padding: 2px 6px;
  border-radius: 4px;
  margin-bottom: 4px;
}

.variable-type {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: $color-text-muted;
  text-transform: uppercase;
}

.variable-description {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: $color-grey-7;
  line-height: 1.35;
}

.no-variables {
  padding: 16px;
  text-align: center;
  color: $color-text-muted;
  font-size: 14px;
}

.copied-toast {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: $color-grey-4;
  color: $color-white;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  animation: fadeIn 200ms cubic-bezier(0.25, 1, 0.5, 1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
</style>
